import React, { createContext, useContext } from 'react';
import { Block } from '../../../services/entities/impl/blfApi/schemas/block';
import { Customer } from '../../../services/entities/impl/blfApi/schemas/customer';
import { Ranch } from '../../../services/entities/impl/blfApi/schemas/ranch';
import { User } from '../../../services/entities/impl/blfApi/schemas/user';
import useFilterOnboardApiData from '../hooks/useFilterOnboardApiData/useFilterOnboardApiData';

export interface OnboardApiDataRaw {
  customers: Customer[] | undefined;
  isLoadingCustomers: boolean;
  ranches: Ranch[] | undefined;
  isLoadingRanches: boolean;
  blocks: Block[] | undefined;
  isLoadingBlocks: boolean;
  users: User[] | undefined;
  isLoadingUsers: boolean;
}

export interface FilteredOnboardApiData {
  customers: Customer[];
  ranches: Ranch[];
  blocks: Block[];
  users: User[];
}

export interface OnboardState {
  ApiDataRaw: OnboardApiDataRaw;
  ApiDataFiltered: FilteredOnboardApiData;
}

interface OnboardProviderProps {
  children: React.ReactNode;
}

// Create the context
export const OnboardContext = createContext<OnboardState | undefined>(
  undefined
);

// Create the provider
export const OnboardProvider: React.FC<OnboardProviderProps> = ({
  children,
}) => {
  // Fetch and filter the onboard data from the API
  const onboardApiData = useFilterOnboardApiData();

  return (
    <OnboardContext.Provider value={onboardApiData}>
      {children}
    </OnboardContext.Provider>
  );
};

export const useOnboardContext = () => {
  const context = useContext(OnboardContext);
  if (!context) {
    throw new Error('useOnboardContext must be used within a OnboardContext');
  }
  return context;
};
